var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit_container"},[_c('vue-editor',{attrs:{"id":"editor","useCustomImageHandler":""},on:{"imageAdded":_vm.handleImageAdded},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }